<template>
  <div>
      <div class="topHeader">
        <div class="common_header" :class="url === '/'?'':'blakBg'">
        <div><img src="../assets/jojo_logo.svg"/></div>
          <div>
            <span :class="url === '/' ? 'mainColor':''" @click="toUrl('/')">Home</span>
            <span :class="url === '/feature' ? 'selectedBg':''" @click="showUpload">Upload Data</span>
            <span :class="url === '/feature' ? 'selectedBg':''" @click="buyData">Buy Data</span>
<!--            <span :class="url === '/feature' ? 'mainColor':''" @click="toUrl('/feature')">Feature</span>-->
            <span :class="url === '/about' ? 'mainColor':''" @click="toUrl('/about')">About</span>
            <div class="downloadDiv">
              <i v-if="!isLogin" class="download" @click="connectWallet">Connect Wallet</i>
              <i v-if="isLogin" class="download" @click="toUrl('/mydata')">My Data</i>
            </div>
          </div>
        </div>
        <div v-if="url !== '/'" class="header_empty"></div>
    </div>
    <div class="mobile_header">
      <div><img src="../assets/jojo_logo.svg" /><img @click="showPageSelect" src="../assets/icon_meun.svg"/></div>
      <div v-if="showPageLi">
         <span :class="url === '/' ? 'selectedBg':''" @click="toUrl('/')">Home</span>
         <span :class="url === '/about' ? 'selectedBg':''" @click="toUrl('/about')">About</span>
      </div>
    </div>
    <UploadGlb ref="uploadGlb" :glbUrl="glbUrl" />
    <BuyData ref="buyData" />
  </div>
</template>

<script>
import * as api from "../service/getData";
import web3 from "../utils";
import Cookies from "js-cookie";
import UploadGlb from "./UploadGlb.vue";
import BuyData from './BuyData.vue';

export default {
  name: 'Header',
  data () {
    return {
      url: '/',
      showPageLi: false,
      showDownload: false,
      isLogin: false,
      glbUrl: null,
      address: ''
    }
  },
  created () {
    this.url = this.$route.path
  },
  mounted () {
    setInterval(() => {
      if (Cookies.get('address')) {
        this.address = Cookies.get('address')
        this.isLogin = true
      } else {
        this.address = ''
        this.isLogin = false
      }
    }, 1000)
  },
  methods: {
    async connectWallet() {
      console.log('connectWallet');
      this.address = await web3.connectWeb3()
      Cookies.set('address', this.address, { expires: 7, path: '' });
      this.isLogin = true
    },
    showUpload() {
      this.$refs.uploadGlb.showUpload()
    },
    buyData() {
      this.$refs.buyData.showBuyData()
    },
    showMaskFn () {
      this.showDownload = true
    },
    hideMaskFn () {
      this.showDownload = false
    },
    showPageSelect () {
      this.showPageLi = !this.showPageLi;
    },
    toUrl (str) {
      this.showPageLi = false
      this.url = str
      this.$router.push(str)
    }
  },
  watch:{
    $route(to,from){
      this.url = to.path
    }
  },
  components: {
    BuyData,
    UploadGlb
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.downloadMask{
  border-radius: 10px;
  background: #FBFBFB;
  padding:30px 30px 25px 30px;
  width: 330px;
  position:absolute;
  right:0px;
  top:70px;
  >div:nth-child(1) {
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 160%;
    font-family: EncodeSans-Regular;
    margin-bottom:8px;
  }
  >div:nth-child(2) {
    >div {
      color: #000;
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      line-height: 160%;
      font-family: EncodeSans-Regular;
      >span:nth-child(1) {
        font-weight: 700;
      }
      >span:nth-child(2) {
        font-weight: 400;
      }
    }
  }
}
@media (max-width: 767px) {
   .topHeader {
     display:none;
   }
   .mobile_header{
     display:block;
   }
}
@media (min-width: 767px) {
   .topHeader {
     display:block;
   }
   .mobile_header{
     display:none;
   }
}
.header_empty {
  height:70px;
}
.mobile_header {
  position:fixed;
  width:100%;
  background:#000;
  z-index:10;
  >div:nth-child(1) {
    padding:20px 20px 0 20px;
    height:35px;
    img:nth-child(1){
      width:120px;
    }
    img:nth-child(2) {
      width:33px;
      height:33px;
      float:right;
    }
  }
  >div:nth-child(2) {
    position:absolute;
    z-index:5;
    right:40px;
    border-radius: 8px;
    background: #3D3D3D;
    width: 87px;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.98);
    span {
      display:block;
      line-height: 48px;
      text-align: center;
      color: #E5E5E5;
      font-size: 15px;
      font-style: normal;
      font-weight: 500;
    }
    .selectedBg{
      border-radius: 8px;
      background: rgba(255, 255, 255, 0.30);
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.35);
    }
  }
}

.common_header {
   height:76px;
   position:fixed;
   top:0px;
   width:100%;
   left:0px;
   z-index:50;
   >div:nth-child(1) {
     padding-left:8%;
     float:left;
     height:100%;
     display:flex;
     justify-content: center;
     img {
       width:157px;
     }
   }
   >div:nth-child(2) {
     float:right;
     display:flex;
     margin-right:8%;
     >span{
       cursor: pointer;
       text-align: center;
       line-height: 70px;
       font-size:16px;
       color: #718083;
       margin-left:44px;
    }
    >span:hover {
      color:#ffffff;
    }
   }
}
.mainColor {
  color: #ffffff !important;
}
.downloadDiv {
  padding-top:15px;
  position:relative;
}
.download {
  cursor: pointer;
  font-size:16px;
  text-align: center;
  margin-left:44px;
  font-size: 16px;
  line-height:46px;
  width: 160px;
  height: 46px;
  font-style:normal;
  border-radius: 360px;
  background: var(--button-linear-default, linear-gradient(90deg, #0FF 25.99%, #6DFBB7 100%));
  color: #030504;
  display:inline-block;
  transition: All 0.2s ease-in-out;
  font-family: "EncodeSans-Medium";
}
.download:hover{
    background: var(--button-linear-hover, linear-gradient(90deg, #80FFFF 25.99%, #24F993 100%));
}
.downBtn {
  margin-top:20px;
  margin-left:86px;
  cursor: pointer;
  img {
    vertical-align: -4px;
    margin-right:5px;
    width:20px;
    height:20px;
  }
   color: #000;
   text-align: center;
   font-family: EncodeSans-Medium;
   font-size: 16px;
   font-style: normal;
   text-decoration: none;
   font-weight: 500;
  display:block;
  text-align: center;
  line-height: 50px;
  width: 158px;
  height: 50px;
  border-radius: 10px;
  background: var(--button-linear-default, linear-gradient(90deg, #0FF 25.99%, #6DFBB7 100%));
}
.downBtn:hover{
    background: var(--button-linear-hover, linear-gradient(90deg, #80FFFF 25.99%, #24F993 100%));
}
.download:hover{
   transform: scale(1.1);
}



</style>



// WEBPACK FOOTER //
// src/components/Header.vue